import { Button, Card, Col, Form, Input, InputNumber, Modal, Radio, Row, Select, Space, Spin, Typography, message } from "antd";
import TextArea from "antd/lib/input/TextArea";
import React, { useEffect, useRef, useState } from "react";
import { BuddhistRangePicker } from "../../../../utils/buddhist-data";
import { DatamanagementService } from "../../services/datamanagement-service";
import { useId24 } from "../../../../drivers/id24/Id24-provider";
import { loadAppConfig } from "../../../../config/app-config";
import dayjs, { Dayjs } from "dayjs";
import { IuserProfile, typeTeam, IDataDetail, ITypeaddconditionNew } from "../../models/models-datamanagement";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { useHistory } from "react-router";
const appConfig = loadAppConfig();

export interface porps {
  baseUrl: string;
  accessRole: string;
}

export const AddConditionRule: React.FC<porps> = ({}): React.ReactElement => {
  const { push } = useHistory();
  const { id24Axios } = useId24();
  const apiBaseUrlCore = id24Axios(appConfig.apiBaseUrl);
  const apiBaseUrlDebt = id24Axios(appConfig.apiBaseUrlDebt);
  const [getdataWorkList, setdataWorkList] = useState<string[]>([]);
  const [getdataFloodStatus, setdataFloodStatus] = useState<string[]>([]);
  const [getdataRiskScore, setdataRiskScore] = useState<string[]>([]);
  const [getdataBillCode, setdataBillCode] = useState<string[]>([]);
  const [getdataCustType, setdataCustType] = useState<string[]>([]);
  const [getdataLastTermCode, setdataLastTermCode] = useState<string[]>([]);
  const [getTeam, setTeam] = useState<typeTeam[]>([]);
  const [getDataSeq, setDataSeq] = useState<number>(0);
  const [getResualDatamanagementDetail, setResualDatamanagementDetail] = useState<IDataDetail[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [checkconditionFive, setconditionFive] = useState<string>("");
  const [checkconditionOsBal, setconditionOsBal] = useState<string>("");
  const [userProfile, setUserprofile] = useState<IuserProfile>({
    id: 0,
    level: "",
    name: "",
    oaCode: "",
    parentId: "",
    team: "",
    token: "",
    type: "",
    capabilities: {},
  });

  const refconditionfive = useRef<any>(null);
  const number_five = useRef<any>(null);

  const refconditionsix = useRef<any>(null);
  const [form] = Form.useForm();

  useEffect(() => {
    const loaddatauser = async () => {
      const resultlProfile: IuserProfile = await DatamanagementService(apiBaseUrlDebt).getUserDetail();
      if (resultlProfile) {
        const resualRulebaseAll = await DatamanagementService(apiBaseUrlCore).getDataRulebase();
        const resFilter = resualRulebaseAll.filter((event: any) => event.name === `User:${resultlProfile.id}:AssignUser`);
        const resual = await DatamanagementService(apiBaseUrlDebt).getTeamByUser(resultlProfile.id);
        setTeam(resual);
        setDataSeq(resFilter[0]?.detail.length);
        setResualDatamanagementDetail(resFilter[0]?.detail);
      }
      setUserprofile(resultlProfile);
    };

    const loaddatadropdown = async () => {
      const resultWorklist: string[] = await DatamanagementService(apiBaseUrlDebt).getdataworklist();
      const resultFloodStatus: string[] = await DatamanagementService(apiBaseUrlDebt).getdatafloodstatus();
      const resultRiskScore: string[] = await DatamanagementService(apiBaseUrlDebt).getdatariskscore();
      const resultBillCode: string[] = await DatamanagementService(apiBaseUrlDebt).getdatabillcode();
      const resultCustType: string[] = await DatamanagementService(apiBaseUrlDebt).getdatacusttype();
      const resultLastTermCode: string[] = await DatamanagementService(apiBaseUrlDebt).getdatalasttermcode();
      setdataWorkList(resultWorklist);
      setdataFloodStatus(resultFloodStatus);
      setdataRiskScore(resultRiskScore);
      setdataBillCode(resultBillCode);
      setdataCustType(resultCustType);
      setdataLastTermCode(resultLastTermCode);
    };
    loaddatadropdown();
    loaddatauser();
    setLoading(false);
  }, [loading, checkconditionFive, checkconditionOsBal]);

  const onchange_no_five = (value: string) => {
    setconditionFive(value);
  };
  const onchange_no_six = (value: string) => {
    if (value === "between") {
      form.resetFields(["osBal"]);
    } else {
      form.resetFields(["osBal_one"]);
      form.resetFields(["osBal_two"]);
    }
    setconditionOsBal(value);
  };

  const checkDataContact = (event: ITypeaddconditionNew) => {
    if (
      (event.billCode === undefined || event.billCode?.length == 0) &&
      event.condition_dtlLastPay === undefined &&
      event.conditon_osBal === undefined &&
      (event.custType === undefined || event.custType?.length == 0) &&
      (event.dates === undefined || event.dates === null) &&
      (event.floodStatus === undefined || event.floodStatus?.length == 0) &&
      (event.lastTermCod === undefined || event.lastTermCod?.length == 0) &&
      (event.number_dtlLastPay === undefined || event.number_dtlLastPay === null) &&
      (event.osBal === undefined || event.osBal === null) &&
      (event.riskScore === undefined || event.riskScore?.length == 0) &&
      (event.workList === undefined || event.workList?.length == 0) &&
      (event.osBal_one === undefined || event.osBal_one === null) &&
      (event.osBal_two === undefined || event.osBal_two === null)
    ) {
      message.warning(`กรุณากรอกข้อมูล อย่างน้อย 1 หัวข้อก่อนกดยืนยัน`);
      return false;
    }

    console.log(event.number_dtlLastPay !== undefined && event.number_dtlLastPay % 1 != 0);

    if (event.number_dtlLastPay !== undefined && event.number_dtlLastPay % 1 != 0) {
      message.warning(`กรุณากรอกจำนวนวันเป็นจำนวนเต็ม`);
      return false;
    }

    const check = String(event.number_dtlLastPay);
    if (check === "0") {
      message.warning(`กรุณากรอกจำนวนที่มากกว่า 0 เป็นต้นไป`);
      return false;
    }

    if (event.number_dtlLastPay > 10000) {
      message.warning(`จำนวนวันที่กรอกนั้นมากเกินไปกรุณาแก้ไขข้อมูลใหม่`);
      return false;
    }

    if (event.condition_dtlLastPay === undefined) {
      if (!!event.number_dtlLastPay || !!event.dates) {
        message.warning(`โปรดกรอกข้อมูลให้ครบตามเงื่อนไข `);
        refconditionfive.current.focus();
        return false;
      }
    }
    if (event.condition_dtlLastPay) {
      if ((event.number_dtlLastPay === undefined || event.number_dtlLastPay === null) && (event.dates === undefined || event.dates === null)) {
        message.warning(`โปรดกรอกข้อมูลให้ครบตามเงื่อนไข `);
        refconditionfive.current.focus();
        return false;
      }
    }
    if (event.condition_dtlLastPay && event.number_dtlLastPay) {
      if (event.dates == undefined || event.dates == null) {
        message.warning(`โปรดเลือกวันที่ในปฏิทิน`);
        refconditionfive.current.focus();
        return false;
      }
    }
    if (event.condition_dtlLastPay && event.dates) {
      if (event.number_dtlLastPay == undefined || event.number_dtlLastPay == null) {
        message.warning(`โปรดกรอกจำนวนวัน`);
        refconditionfive.current.focus();
        return false;
      }
    }

    // os check value
    if (checkconditionOsBal !== "between" && (checkconditionOsBal === undefined || checkconditionOsBal === "")) {
      if (event.osBal != undefined || event.osBal != null) {
        message.warning(`โปรดกรอกข้อมูลในส่วน condition OS `);
        refconditionsix.current.focus();
        return false;
      }
    }

    if (checkconditionOsBal !== "between" && !!checkconditionOsBal) {
      if (event.osBal === undefined || event.osBal === null) {
        message.warning(`โปรดกรอกข้อมูลจำนวน OS`);
        refconditionsix.current.focus();
        return false;
      }
    }

    if (checkconditionOsBal === "between") {
      if ((event.osBal_one === undefined && event.osBal_two === undefined) || (event.osBal_one === null && event.osBal_two === null)) {
        message.warning(`โปรดกรอกข้อมูลให้ครบตามเงื่อนไข`);
        refconditionsix.current.focus();
        return false;
      }
    }
    if (checkconditionOsBal === "between") {
      if ((event.osBal_one != undefined && event.osBal_two === undefined) || (event.osBal_one != null && event.osBal_two === null)) {
        message.warning(`โปรดกรอกข้อมูลจำนวน OS ให้ครบถ้วน`);
        refconditionsix.current.focus();
        return false;
      }
    }
    if (checkconditionOsBal === "between") {
      if ((event.osBal_one === undefined && event.osBal_two != undefined) || (event.osBal_one === null && event.osBal_two != null)) {
        message.warning(`โปรดกรอกข้อมูลจำนวน OS ให้ครบถ้วน`);
        refconditionsix.current.focus();
        return false;
      }
    }
    return true;
  };

  const onFinish = (event: ITypeaddconditionNew) => {
    const check = checkDataContact(event);
    if (check === true) {
      Modal.confirm({
        title: "คุณแน่ใจแล้วใช่ไหม",
        icon: <ExclamationCircleOutlined />,
        content: "กดยืนยันเพื่อบันทึกข้อมูล",
        okText: "ยืนยัน",
        cancelText: "ยกเลิก",
        onOk: async () => {
          let AssignUserNew = `User:${userProfile?.id}:AssignUser` as any;
          let seqPlust = getDataSeq + 1;
          let datatime: string | Dayjs = "";
          if (event?.condition_dtlLastPay === ">") {
            datatime = dayjs(event.dates).add(event?.number_dtlLastPay, "day");
          } else {
            datatime = dayjs(event.dates).subtract(event?.number_dtlLastPay, "day");
          }
          const datatimeStamp = datatime.unix();
          let fieldsInstan: any = {};
          let workList: any;
          event.workList === undefined || event?.workList?.length === 0
            ? (workList = null)
            : ((workList = {
                op: "in",
                type: "STRING",
                value: event.workList,
              }),
              (fieldsInstan = {
                ...fieldsInstan,
                workList,
              }));
          let floodStatus: any;
          event.floodStatus === undefined || event?.floodStatus?.length === 0
            ? (floodStatus = null)
            : ((floodStatus = {
                op: "in",
                type: "STRING",
                value: event.floodStatus,
              }),
              (fieldsInstan = {
                ...fieldsInstan,
                floodStatus,
              }));
          let billCode: any;
          event.billCode === undefined || event?.billCode?.length === 0
            ? (billCode = null)
            : ((billCode = {
                op: "in",
                type: "STRING",
                value: event.billCode,
              }),
              (fieldsInstan = {
                ...fieldsInstan,
                billCode,
              }));
          let riskScore: any;
          event.riskScore === undefined || event?.riskScore?.length === 0
            ? (riskScore = null)
            : ((riskScore = {
                op: "in",
                type: "STRING",
                value: event.riskScore,
              }),
              (fieldsInstan = {
                ...fieldsInstan,
                riskScore,
              }));
          let osBal: any;
          event.conditon_osBal === "between"
            ? event.osBal_one === undefined || event.osBal_two === undefined
              ? (osBal = null)
              : ((osBal = {
                  op: event.conditon_osBal,
                  type: "NUMBER",
                  value: [Number(event.osBal_one), Number(event.osBal_two)],
                }),
                (fieldsInstan = {
                  ...fieldsInstan,
                  osBal,
                }))
            : event.osBal === undefined
            ? (osBal = null)
            : ((osBal = {
                op: event.conditon_osBal,
                type: "NUMBER",
                value: Number(event.osBal),
              }),
              (fieldsInstan = {
                ...fieldsInstan,
                osBal,
              }));
          let custType: any;
          event.custType === undefined || event?.custType?.length === 0
            ? (custType = null)
            : ((custType = {
                op: "in",
                type: "STRING",
                value: event.custType,
              }),
              (fieldsInstan = {
                ...fieldsInstan,
                custType,
              }));
          let lastTermCode: any;
          event.lastTermCod === undefined || event?.lastTermCod?.length === 0
            ? (lastTermCode = null)
            : ((lastTermCode = {
                op: "in",
                type: "STRING",
                value: event.lastTermCod,
              }),
              (fieldsInstan = {
                ...fieldsInstan,
                lastTermCode,
              }));
          let dtlLastPay: any;
          event.dates === undefined || event.dates === null
            ? (dtlLastPay = null)
            : ((dtlLastPay = {
                op: event.condition_dtlLastPay,
                type: "NUMBER",
                value: datatimeStamp,
              }),
              (fieldsInstan = {
                ...fieldsInstan,
                dtlLastPay,
              }));
          let condition: any[] = [
            {
              fields: fieldsInstan,
              seq: getDataSeq >= 1 ? Number(seqPlust) : 1,
              distribution: event.team,
              days: 120,
              assignType: "Manual",
              type: "BASIC",
              status: event.buttonSubmit,
              createBy: Number(userProfile?.id),
              listname: event.condition_name,
              updateBy: userProfile?.name,
              createDate: dayjs().format("YYYY-MM-DD HH:mm:ss"),
              description: event.description ? event.description : "",
              number_dtlLastPay: event.number_dtlLastPay,
            },
          ];
          if (getDataSeq >= 1) {
            getResualDatamanagementDetail.forEach((x: IDataDetail) => {
              condition.push(x);
            });
          }
          const rulesCreateBasic = [];
          rulesCreateBasic.push({
            name: AssignUserNew,
            detail: condition,
          });
          const apiMethod = getDataSeq >= 1 ? "updateConditionByid" : "createCondition";
          if (apiMethod === "updateConditionByid") {
            const resual = await DatamanagementService(apiBaseUrlCore).updateConditionByid(AssignUserNew, rulesCreateBasic);
            if (resual) {
              message.success("Success");
              push("/datamanagement");
            }
          } else {
            const resual = await DatamanagementService(apiBaseUrlCore).createCondition(rulesCreateBasic);
            if (resual) {
              message.success("Success");
              push("/datamanagement");
            }
          }
        },
        onCancel: () => {},
      });
    }
  };

  return loading ? (
    <div style={{ height: "700px", justifyContent: "center", display: "flex", alignItems: "center" }}>
      <Spin />
    </div>
  ) : (
    <Row
      gutter={[
        { xs: 8, sm: 16 },
        { xs: 8, sm: 16 },
      ]}
      style={{ marginTop: "2rem" }}
    >
      <Card style={{ width: "100%", textAlign: "left" }} title="Add Condition List">
        <Form form={form} labelCol={{ span: 4 }} wrapperCol={{ span: 20 }} name="add_condition" onFinish={onFinish}>
          <Row gutter={[8, 8]}>
            <Col span={24} style={{ paddingRight: "100px" }}>
              <Form.Item label="Condition List Name :" name={`condition_name`} rules={[{ required: true, message: "กรุณากรอก Condition List Name" }]}>
                <Input />
              </Form.Item>
            </Col>
            <Col span={24} style={{ paddingRight: "100px" }}>
              <Form.Item label="Description :" name={`description`}>
                <TextArea rows={4} showCount maxLength={250} />
              </Form.Item>
            </Col>
            <Col span={2} style={{ justifyContent: "center", display: "flex" }}>
              <Typography style={{ fontWeight: "bold" }}>{`No.`}</Typography>
            </Col>
            <Col span={12}>
              <Typography style={{ fontWeight: "bold" }}>{`Field`}</Typography>
            </Col>
            <Col span={10}>
              <Typography style={{ fontWeight: "bold" }}>{`Value`}</Typography>
            </Col>
            <Col span={2} style={{ justifyContent: "center", display: "flex" }}>
              <Typography>{`1.`}</Typography>
            </Col>
            <Col span={12}>
              <Input value={`Worklist`} readOnly />
            </Col>
            <Col span={10}>
              <Form.Item name={`workList`} style={{ width: "100%" }}>
                <Select
                  showArrow
                  mode="multiple"
                  style={{ width: "100%" }}
                  placeholder={`Please Select`}
                  options={getdataWorkList?.map((value: string, index: number) => ({ label: value, value: value, key: index }))}
                />
              </Form.Item>
            </Col>
            <Col span={2} style={{ justifyContent: "center", display: "flex" }}>
              <Typography>{`2.`}</Typography>
            </Col>
            <Col span={12}>
              <Input value={`สีน้ำท่วม`} readOnly />
            </Col>
            <Col span={10}>
              <Form.Item name={`floodStatus`}>
                <Select
                  showArrow
                  style={{ width: "100%" }}
                  mode="multiple"
                  placeholder={`Please Select`}
                  options={getdataFloodStatus?.map((value: string, index: number) => ({ label: value, value: value, key: index }))}
                />
              </Form.Item>
            </Col>
            <Col span={2} style={{ justifyContent: "center", display: "flex" }}>
              <Typography>{`3.`}</Typography>
            </Col>
            <Col span={12}>
              <Input value={`Bscore`} readOnly />
            </Col>
            <Col span={10}>
              <Form.Item name={`riskScore`}>
                <Select
                  showArrow
                  style={{ width: "100%" }}
                  mode="multiple"
                  placeholder={`Please Select`}
                  options={getdataRiskScore?.map((value: string, index: number) => ({ label: value, value: value, key: index }))}
                />
              </Form.Item>
            </Col>
            <Col span={2} style={{ justifyContent: "center", display: "flex" }}>
              <Typography>{`4.`}</Typography>
            </Col>
            <Col span={12}>
              <Input value={`Billcode`} readOnly />
            </Col>
            <Col span={10}>
              <Form.Item name={`billCode`}>
                <Select
                  showArrow
                  style={{ width: "100%" }}
                  mode="multiple"
                  placeholder={`Please Select`}
                  options={getdataBillCode?.map((value: string, index: number) => ({ label: value, value: value, key: index }))}
                />
              </Form.Item>
            </Col>
            <Col span={2} style={{ justifyContent: "center", display: "flex" }}>
              <Typography>{`5.`}</Typography>
            </Col>
            <Col span={6}>
              <Input value={`สัญญาที่มีการจ่ายภายใน`} readOnly />
            </Col>
            <Col span={6}>
              <Form.Item name={`condition_dtlLastPay`}>
                <Select
                  showArrow
                  allowClear
                  placeholder="Please Select"
                  style={{ width: "100%" }}
                  options={[
                    { label: ">", value: ">", key: 1 },
                    { label: "<", value: "<", key: 2 },
                  ]}
                  onChange={(e) => onchange_no_five(e)}
                  ref={refconditionfive}
                />
              </Form.Item>
            </Col>
            <Col span={10}>
              <Row gutter={[8, 8]}>
                <Col span={10}>
                  <Form.Item name={`number_dtlLastPay`}>
                    <InputNumber
                      ref={number_five}
                      style={{ width: "100%" }}
                      stringMode
                      formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                      // parser={(value: any) => parseFloat(value.replace(/\$\s?|(,*)/g, "")) || 0}
                      parser={(value: any) => {
                        // Remove any non-numeric characters and parse to a float
                        const numericValue = parseFloat(value.replace(/\$\s?|(,*)/g, ""));
                        return isNaN(numericValue) ? "" : numericValue;
                      }}
                      placeholder="Number of Days"
                      min={0}
                    />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <BuddhistRangePicker />
                </Col>
              </Row>
            </Col>
            <Col span={2} style={{ justifyContent: "center", display: "flex" }}>
              <Typography>{`6.`}</Typography>
            </Col>
            <Col span={12}>
              <Row gutter={[8, 8]}>
                <Col span={12}>
                  <Input value={`OS`} readOnly />
                </Col>
                <Col span={12}>
                  <Form.Item name={`conditon_osBal`}>
                    <Select
                      showArrow
                      allowClear
                      placeholder="Please Select"
                      style={{ width: "100%" }}
                      options={[
                        { label: ">", value: ">", key: 1 },
                        { label: ">=", value: ">=", key: 2 },
                        { label: "<", value: "<", key: 3 },
                        { label: "<=", value: "<=", key: 4 },
                        { label: "!=", value: "!=", key: 5 },
                        { label: "=", value: "=", key: 6 },
                        { label: "Between", value: "between", key: 7 },
                      ]}
                      onChange={(e) => onchange_no_six(e)}
                      ref={refconditionsix}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Col>
            {checkconditionOsBal === "between" ? (
              <>
                <Col span={4}>
                  <Form.Item name={`osBal_one`}>
                    <InputNumber
                      stringMode
                      formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                      parser={(value: any) => {
                        const numericValue = parseFloat(value.replace(/\$\s?|(,*)/g, ""));
                        return isNaN(numericValue) ? "" : numericValue;
                      }}
                      placeholder="Number"
                      style={{ width: "100%" }}
                    />
                  </Form.Item>
                </Col>
                <Col span={1}>
                  <Form.Item>
                    <Typography.Text>{`ถึง`}</Typography.Text>
                  </Form.Item>
                </Col>
                <Col span={4}>
                  <Form.Item name={`osBal_two`}>
                    <InputNumber
                      stringMode
                      // formatter={(value: any) => `${parseFloat(value).toFixed(2)}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                      formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                      // parser={(value) => value!.replace(/\$\s?|(,*)/g, "")}
                      // parser={(value: any) => parseFloat(value.replace(/\$\s?|(,*)/g, "")) || 0}
                      parser={(value: any) => {
                        // Remove any non-numeric characters and parse to a float with 2 decimal places
                        const numericValue = parseFloat(value.replace(/\$\s?|(,*)/g, ""));
                        return isNaN(numericValue) ? "" : numericValue;
                      }}
                      placeholder="Number"
                      style={{ width: "100%" }}
                    />
                  </Form.Item>
                </Col>
              </>
            ) : (
              <Col span={10}>
                <Form.Item name={`osBal`}>
                  <InputNumber
                    stringMode
                    formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                    // formatter={(value: any) => `${parseFloat(value).toFixed(2)}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                    parser={(value: any) => {
                      const numericValue = parseFloat(value.replace(/\$\s?|(,*)/g, ""));
                      return isNaN(numericValue) ? "" : numericValue;
                    }}
                    style={{ width: "100%" }}
                    placeholder="Number"
                  />
                </Form.Item>
              </Col>
            )}

            <Col span={2} style={{ justifyContent: "center", display: "flex" }}>
              <Typography>{`7.`}</Typography>
            </Col>
            <Col span={12}>
              <Input value={`ประเภทลูกค้า`} readOnly />
            </Col>
            <Col span={10}>
              <Form.Item name={`custType`}>
                <Select
                  showArrow
                  style={{ width: "100%" }}
                  mode="multiple"
                  placeholder={`Please Select`}
                  options={getdataCustType?.map((value: string, index: number) => ({ label: value, value: value, key: index }))}
                />
              </Form.Item>
            </Col>
            <Col span={2} style={{ justifyContent: "center", display: "flex" }}>
              <Typography>{`8.`}</Typography>
            </Col>
            <Col span={12}>
              <Input value={`Last Result`} readOnly />
            </Col>
            <Col span={10}>
              <Form.Item name={`lastTermCod`}>
                <Select
                  showArrow
                  style={{ width: "100%" }}
                  placeholder={`Please Select`}
                  mode="multiple"
                  options={getdataLastTermCode?.map((value: string, index: number) => ({ label: value, value: value, key: index }))}
                />
              </Form.Item>
            </Col>
            <Form.Item name="buttonSubmit" style={{ display: "none" }}>
              <Input type="hidden" />
            </Form.Item>
            <Col span={24}>
              <Form.Item label={`Team`} name={`team`} rules={[{ required: true, message: "กรุณาเลือก Team" }]}>
                <Select
                  showArrow
                  style={{ width: "20%" }}
                  placeholder="Select Team"
                  showSearch
                  allowClear
                  optionFilterProp="label"
                  options={getTeam?.map((x: typeTeam, index: number) => ({ label: x.name, value: x.id, key: index }))}
                />
              </Form.Item>
            </Col>
            <Row style={{ marginLeft: "100px", paddingLeft: "10px" }} gutter={[8, 8]}>
              <Col>
                <Button
                  type="primary"
                  htmlType="submit"
                  style={{ border: "none", backgroundColor: "#FAAF39" }}
                  onClick={() => form.setFieldsValue({ buttonSubmit: "DRAFT" })}
                >
                  {`Save Draft`}
                </Button>
              </Col>
              <Col>
                <Button
                  type="primary"
                  style={{ backgroundColor: "#52c41a", border: "none" }}
                  htmlType="submit"
                  onClick={() => form.setFieldsValue({ buttonSubmit: "APPROVED" })}
                >
                  {`Approved`}
                </Button>
              </Col>
            </Row>
          </Row>
        </Form>
      </Card>
    </Row>
  );
};
